import styled from "styled-components";
import {
    ExtLinkColor,
    Gray12,
    Gray20,
    Gray25, Gray5, HoverRowColor,
    IframeVideoColor,
    SAPBadgeColor, StripedRowColor, SuggestionBoxEntryColor,
    WerfenColor, WerfenColorContrast,
    White,
    Dark4,
    Dark
} from "../../../../Constants/ColorChart";
import { Badge } from "react-bootstrap";

export const PictureAndTextDiv = styled.div`
    //margin: 0 0.5vw;
    padding-left: 5px;
    position: relative;
`;

export const ClickableDiv = styled.div`
    z-index: 10;
    ${ props => props.showPointer && "&:hover{cursor:pointer;}" }
`;

export const IconContainer = styled.span`
    margin: 2px;
    cursor: pointer;
    &.iconContainer{
        position: relative;
    }
    &.iconContainer[data-title]{    
        color: transparent;
        &:hover::after {
            content: attr(data-title);
            position: absolute;
            top: -35px;
            left: calc(-50%);
            background: ${ White } !important;
            color:  ${ WerfenColor }!important;
            font-size: 14px;
            padding: 4px 10px;
            border-radius: 4px;
            border: 1px solid ${ WerfenColor };
            white-space: pre;
        }
    }
    
    &.iconContainer[data-title].iconBottom {
        &:hover::after {
            top: 50px !important;
        }
    }

    &.iconContainer[data-title].iconActivity {
        &:hover::after {
            top: 50px !important;
            left: -100px;
        }
    }

    &.iconContainer[data-title].iconProfile {
        &:hover::after {
            top: 50px !important;
            left: -200px;
        }
    }

    .ShareLink {
        position: absolute;
        top: -117px;
        background: ${ White };
        padding: 10px 20px;
        border: 0.5px solid ${ Gray25 };
        z-index: 1;
        right: -17px;
        font-size: 16px;
        min-width: 300px;
        &-title {
            display: block;
            text-align: left;
        }
        &-close {
            position: absolute;
            top: 6px;
            right: 10px;
        }
        input {
            width: 100%;
        }
        .smallText{
            display: block;
        }
        .disappear {
            opacity: 0;
            transition: opacity 400ms;
        }
    }
    .ShareLink:before {
        content: " ";
        display: block;
        position: absolute;
        width: 12px;
        height: 12px;
        background: ${ White };
        bottom: -6px;
        right: 20px;
        transform: rotate(45deg);
        z-index: -1;
        box-shadow: 1.5px 1.5px ${ Gray20 };
    }
`;

export const RowNameContainer = styled.div`
    ${ props => props.uniqueRowText && `width: 100%; margin-left: 0.5vw` }
    ${ props => props.tableUnified && props.laptopFormat === false && `width: 9vw` }
    ${ props => props.laptopFormat && `width: 8vw` }
    margin-top: auto;
    margin-bottom: auto;
`;

export const StyledBadge = styled ( Badge )`
    background-color: ${ props => props.sapBadge ? SAPBadgeColor : Dark  } !important  ;
    color: ${ props => props.sapBadge ? White : Dark4  } !important;
    font-size: 8px!important;
    margin-left: 8px;
    margin-top: -8px;
    border-radius: 0.5rem!important;
    vertical-align: middle!important;
    padding: 4px 8px !important;
    cursor: ${ props => props.sapBadge ? "pointer" : "default" };
`;

export const StyledBokeccVideoBadge = styled ( Badge )`
    background-color: ${ IframeVideoColor }!important;
    color: ${ White }!important;
    font-size: 0.55rem!important;
    margin-left: 8px;
    margin-top: -2px;
    padding-right: 0.5rem!important;
    padding-left: 0.5rem!important;
    border-radius: 0.5rem!important;
    vertical-align: middle!important;
`;

export const StyledExtLinkBadge = styled ( Badge )`
    background-color: ${ ExtLinkColor }!important;
    color: ${ White }!important;
    font-size: 0.55rem!important;
    margin-left: 8px;
    margin-top: -2px;
    padding-right: 0.5rem!important;
    padding-left: 0.5rem!important;
    border-radius: 0.5rem!important;
    vertical-align: middle!important;
`;

export const RowName = styled.span`
    overflow-wrap: break-word;
    word-break: break-word;
    margin-top: auto;
    margin-bottom: auto;
`;

export const TableData = styled.td`
    font-size: 12px;
    padding-top: 10px;
    padding-bottom: 10px;
    ${ props => props.textAlignRight && "text-align: right; padding-right: 15px;" }
    &.checkbox{
        padding-bottom: 14px;
        text-align:center;
        width: 30px;
        white-space:pre;
    }
    &.actions{
        white-space:pre;
    }
    @media screen and (min-width: 768px){
        font-size: 15px;
    }
    @media screen and (min-width: 992px){
        font-size: 17px;
    }
    @media screen and (min-width: 1200px){
        font-size: 19px;
    }
`;

export const TableRow = styled.tr`
    border-top: 1px solid ${ Gray12 };
    &.odd {
        background: ${ StripedRowColor };
    }
    &.even + .even, &.odd + .odd {
        border-top: 0 none transparent;
    }
    &.specialBgColor {
        background: ${ WerfenColorContrast }
    }
    &:not(.description):hover:not(.progress-wrapper):hover,
    &.even:hover + .even,
    &.even:hover + .even + .even,
    &.odd:hover + .odd,
    &.odd:hover + .odd + .odd {
        background: ${ HoverRowColor };
        box-shadow: 0px 0px 20px ${ HoverRowColor };
    }
    &.description{
        &.extra-padding td{
            padding-left: 30px!important
        }
        .accordionWrapper{
            padding:0!important
        }
        .accordion{
            max-height: 0px;
            overflow: hidden;
            transition: all 0.3s ease-in-out;
            transition-property: max-height, padding-bottom;
            padding-left: 20px;
            padding-right: 20px;
            padding-bottom:0px;
            font-size: 15px;
            color: ${ SuggestionBoxEntryColor }
            &.open{
            max-height: 1000px;
            padding-bottom: 20px;
        }
        }
    }
    transition: all 100ms;

    .progress {
        height: 6px;
        margin-top: 10px;
        margin-right: 20px;
        margin-left: 0.5vw;
        border-radius: 0;
        background: ${ Gray5 };
        box-shadow: unset;
        .progress-bar {
            background: ${ WerfenColor }
        }
    }
`;

export const StyledName = styled.span`{
    display: block;
    width: 90%; 
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
}`

export const StyledTagBadgeDiv = styled.div` {
    display: flex;
    padding:  20px 0 5px 0
}`
